module.exports = __webpack_public_path__ + "static/media/s3.9687ecac.png";